import { render, staticRenderFns } from "./MySpace.vue?vue&type=template&id=cafe6284"
import script from "./MySpace.vue?vue&type=script&lang=js"
export * from "./MySpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports